var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"screenfull",attrs:{"id":"screenfull"}},[_c('i',{staticClass:"iconfont",class:_vm.isFullscreen? 'icon-exitfullscreen': 'icon-fullscreen',on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }